import { IconButton, Tooltip, VStack } from '@chakra-ui/react';
import { ArrowDown, ArrowUp } from 'lucide-react';
import { dimUntilHoverControl } from '@/modules/content/loop/model/loopChrome';

type Props = {
  canGoPrevious: boolean;
  canGoNext: boolean;
  onPrevious: () => void;
  onNext: () => void;
};

const buttonProps = {
  borderRadius: 'full',
  width: '38px',
  height: '38px',
  minWidth: '38px',
  backgroundColor: 'white',
  color: 'text.darkBlue',
  boxShadow: '0px 4px 14px rgba(14, 0, 98, 0.10)',
  ...dimUntilHoverControl,
  _hover: { opacity: 1, color: 'primary.500', transform: 'translateY(-2px)' },
} as const;

// Vertical navigation, kept visually apart from the reactions rail so "move through the
// feed" never reads as another reaction. Touch users swipe instead.
const LoopNavigation = ({ canGoPrevious, canGoNext, onPrevious, onNext }: Props) => (
  <VStack gap="12px" flexShrink={0}>
    <Tooltip label="Previous" placement="left" hasArrow>
      <IconButton
        aria-label="Previous item"
        icon={<ArrowUp size={18} />}
        isDisabled={!canGoPrevious}
        onClick={onPrevious}
        {...buttonProps}
      />
    </Tooltip>
    <Tooltip label="Next" placement="left" hasArrow>
      <IconButton
        aria-label="Next item"
        icon={<ArrowDown size={18} />}
        isDisabled={!canGoNext}
        onClick={onNext}
        {...buttonProps}
      />
    </Tooltip>
  </VStack>
);

export default LoopNavigation;
